import { configureStore } from '@reduxjs/toolkit';

import parcelReducer from './parcel/parcelSlice';
import upsReducer from './ups/upsSlice';
import userSessionReducer from './userSession/userSessionSlice';

export const store = configureStore({
  reducer: {
    userSession: userSessionReducer,
    parcel: parcelReducer,
    ups: upsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
